// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import GridPanelEditTemplate from '@front/templates/GridPanelEditTemplate.html';
import { Rectangle } from '@shared/commons/Geometry';
import { Resources } from '@shared/localizations/Resources';
import { MathUtils } from '@shared/utils/MathUtils';
import { ContainerControl } from './ContainerControl';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
export class GridPanelEdit extends ContainerControl {
    constructor(initProps = null, x, y, data, callBack, onClose) {
        super(initProps);
        this.lostFocusOnOutsideClick = true;
        this.onNewGridSizeSelected = this.onNewGridSizeSelected.bind(this);
        this.needResetLayout = this.needResetLayout.bind(this);
        const popupRectngle = new Rectangle(x, y, super.get('width'), super.get('height'));
        const correctedRectangle = ControlsUtils.CorrectPopupLocation(popupRectngle);
        this.callBack = callBack;
        this.onClose = onClose;
        this.initialPosition = {
            left: correctedRectangle.newX,
            top: correctedRectangle.newY,
            defaultRowsSelected: data.rows,
            defaultColumnsSelected: data.columns
        };
    }
    getType() {
        return 'GridPanelEdit';
    }
    oninit() {
        super.oninit();
        void super.set('textResetButton', Resources.getResource('panel.GridPanel.resetMI.Text'));
        super.on('newGridSizeSelected', this.onNewGridSizeSelected);
        super.on('resetButtonClick', this.needResetLayout);
    }
    oncomplete() {
        super.oncomplete();
        const { left, top, defaultRowsSelected, defaultColumnsSelected } = this.initialPosition;
        void super.set({ left, top, defaultRowsSelected, defaultColumnsSelected });
    }
    setFocus() {
        super.setFocus();
    }
    lostFocus() {
        super.lostFocus();
        this.hide();
    }
    hide() {
        if (!isNullOrUndefined(this.onClose)) {
            this.onClose();
        }
        MainWindowManager.MainWindow.removeControl(this);
    }
    onNewGridSizeSelected(context, rows, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.applyChanges({ rows, columns });
        });
    }
    needResetLayout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.applyChanges({ resetLayout: true });
        });
    }
    applyChanges(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!MathUtils.IsNullOrUndefined(this.callBack)) {
                yield this.callBack(data);
            }
            this.hide();
        });
    }
    static show(x, y, data, callBack, onClose) {
        const gridPanelEdit = new GridPanelEdit(undefined, x, y, data, callBack, onClose);
        MainWindowManager.AddControl(gridPanelEdit);
        gridPanelEdit.setFocus();
    }
}
ContainerControl.extendWith(GridPanelEdit, {
    template: GridPanelEditTemplate,
    data: function () {
        return {
            defaultRowsSelected: 1,
            defaultColumnsSelected: 1,
            textResetButton: ''
        };
    }
});
